module.exports = __webpack_public_path__ + "static/media/csharp-logo.a634d2be.svg";